import { useEffect, useState } from 'react'
import { ClientPortfolioSortBy } from '@black-bear-energy/black-bear-energy-common'
import { Box } from '@black-bear-energy/rucksack'
import { useProjectSummaries } from '../../api/hooks/useProjectSummaries'
import { ProjectsTable } from '../../components/Dashboard/ProjectsTable'

export function ClientProjectsSection() {
  const [search, setSearch] = useState('')
  const [sortBy, setSortBy] = useState(ClientPortfolioSortBy.Name)
  const [sortAsc, setSortAsc] = useState(true)
  const [page, setPage] = useState(1)

  const { data, isPending, isError, error } = useProjectSummaries(
    search,
    sortBy,
    sortAsc,
    page
  )

  useEffect(() => {
    if (error) {
      console.error(
        '[ClientProjectsSection] Failed to fetch project summaries',
        error
      )
    }
  }, [error])

  const records = data?.records ?? []
  const totalPages = data?.pagination.totalPages ?? 1

  function resetPage() {
    setPage(1)
  }

  function handleSortBy(newSortBy: ClientPortfolioSortBy) {
    setSortBy(newSortBy)
    resetPage()
  }

  function handleSortAsc(newSortAsc: boolean) {
    setSortAsc(newSortAsc)
    resetPage()
  }

  function handleSearch(newSearch: string) {
    setSearch(newSearch)
    resetPage()
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <ProjectsTable
        records={records}
        isPending={isPending}
        isError={isError}
        sortBy={sortBy}
        setSortBy={handleSortBy}
        sortAsc={sortAsc}
        setSortAsc={handleSortAsc}
        search={search}
        setSearch={handleSearch}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
      />
    </Box>
  )
}
